import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  Button, Row, Spin, PageHeader, Col, Space, message, Modal, Input, Form,
  Select,
} from 'antd'
import {
  LeftOutlined, PlusOutlined, SyncOutlined,
} from '@ant-design/icons'

import { useRecoilState } from 'recoil'

import { fetch } from '../../utils/fetch'
import OrderStatus from '../component/OrderStatus'

import {
  roundingState, totalPriceState, discountPriceState, netPriceState, discountTypeState, editOrder,
  userState,
} from '../../store/atoms'

import TempSoComponent from './component/TempSo'
import SapSoComponent from './component/SapSo'
import OrderHeader from './component/OrderHeader'

import DiscountTotalSoPrice from './component/DiscountTotalSoPrice'

const { Option } = Select
const CreateOrder = (props) => {
  const history = useHistory()

  const { orderId } = props?.match?.params
  const [visible, setVisible] = useState(false)
  const [isFixItemCat, setIsFixItemCat] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [disableCreateBtn, setDisableCreateBtn] = useState(true)
  // const [disableConfirmBtn, setDisableConfirmBtn] = useState(false)
  const [simData, setSimData] = useState([])
  const [rounding, setRounding] = useRecoilState(roundingState)
  const [totalPrice, setTotalPrice] = useRecoilState(totalPriceState)
  const [discountValue, setDiscountValue] = useRecoilState(discountPriceState)
  const [discountType, setDiscountType] = useRecoilState(discountTypeState)
  const [netPrice, setNetPrice] = useRecoilState(netPriceState)
  const [editOrderBtn, setEditOrderBtn] = useRecoilState(editOrder)
  const [orderType, setOrderType] = useState(null)
  const [orderSoQueue, setOrderSoQueue] = useState({})
  const [orderShipto, setOrderShipto] = useState('')
  const [selectedOrderType, setSelectedOrderType] = useState('so')
  // const [isAssetCatVisible, setAssetCatVisible] = useState(true)
  // const [isAssNoVisible, setIsAssNoVisible] = useState(false)

  const [form] = Form.useForm()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  }

  const getHeaderData = async () => {
    await fetch({
      url: `/order/${orderId}/header`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        const headerData = res.data.data
        // console.log(`Header : ${JSON.stringify(headerData)}`)
        setOrderShipto(headerData.shipTo)
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      setIsLoading(false)
    })
  }

  const getOrderData = () => {
    fetch({
      url: `/order/${orderId}`,
    }).then((res) => {
      // console.log(res)
      if (res.data?.success) {
        // setOrderData(res.data?.data)
        setOrderSoQueue(res.data?.data?.orderSoQueue)
        setOrderType(res.data?.data?.orderType)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const getOrderStatus = () => {
    fetch({
      url: `/order/${orderId}/status`,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res?.data?.success) {
        if (['DRF'].includes(res.data.data[res.data.data.length - 1].statusCode)) {
          getOrderData()
        } else {
          return (
            history.push('/page-not-found')
          )
        }
      } else {
        setIsLoading(false)
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
      // setIsLoading(false)
    })
  }

  const onQueueChange = () => {
    getOrderData()
  }

  useEffect(
    () => {
      getHeaderData()
      getOrderStatus()
      setRounding(false)
    },
    [orderId],
  )
  useEffect(() => {
    form.setFieldsValue({
      username: '',
      password: '',
      order: 'so',
      docType: '',
      assetCat: '',
      assNo: '',
    })
  }, [visible])

  const createSo = async (username, password, order, docType, assetCat, assNo) => {
    setIsLoading(true)
    if (order === 'pr1') {
      docType = 'HQC'
      assetCat = 'A'
    } else if (order === 'pr2') {
      docType = '1NB'
    } else if (order === 'pr3') {
      docType = 'HQC'
      assetCat = 'K'
    }
    await fetch({
      method: 'POST',
      url: `/order/${orderId}/${orderType}/${order === 'pr1' || order === 'pr2' || order === 'pr3' ? 'pr' : 'so'}`,
      data: {
        shipTo: orderShipto,
        orderPrice: {
          totalPrice, discountType, discountValue, netPrice, rounding,
        },
        sapUser: {
          username,
          password,
        },
        docType,
        assetCat,
        assNo,
      },
    }).then((res) => {
      setTimeout(() => {
        setIsLoading(false)
        if (res?.data?.success) {
          message.success('Create Success')
          if (orderType !== 'DSB') {
            history.push(`/order/submit/${orderId}`)
            window.location.reload()
          } else {
            history.push(`/order/complete/${orderId}`)
            window.location.reload()
          }
        } else {
          message.error(res?.data?.message)
        }
      }, 5000)
    })
  }

  const simulationSo = () => {
    setIsLoading(true)
    fetch({
      method: 'POST',
      url: `/order/${orderId}/${orderType}/simulate`,
      data: {
        orderPrice: {
          totalPrice, discountValue, discountType, netPrice, rounding,
        },
      },
    }).then((res) => {
      setIsLoading(false)
      if (res?.data?.success) {
        message.success('Simulation Success')
        setEditOrderBtn(false)
        setDisableCreateBtn(false)
        console.log('returnSim', res?.data?.data)
        setSimData(res?.data?.data)
      } else {
        message.error(res?.data?.message)
        setDisableCreateBtn(true)
      }
    })
  }

  const confirmCreateDSB = () => {
    const { confirm } = Modal
    confirm({
      title: 'Create SO',
      content: 'Are you sure to create so ?',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        createSo()
      },
    })
  }

  const handleOrderChange = (value) => {
    setSelectedOrderType(value)

    if (value !== 'pr1') {
      form.setFieldsValue({
        assNo: '',
      })
    }
  }

  const handleCancel = () => {
    setVisible(false)
    // setIsAssNoVisible(false)
    setSelectedOrderType('so')
    // form.resetFields(['docType', 'assetCat']) // Reset fields when canceling
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={`Create Order: ${orderId} `}
          subTitle={<OrderStatus click={false} orderStatus="DRF" orderStatusDesc="Draft" />}

        >
          {/* <RenderComponentOrder orderId={orderId} orderType={orderType} simData={simData} orderSoQueue={orderSoQueue} onQueueChange={onQueueChange} /> */}
          <Row gutter={[8, 32]}>
            <Col span={24}>
              <OrderHeader orderId={orderId} orderType={orderType} onChangeShipTo={getHeaderData} onSetIsFixItemCat={setIsFixItemCat} />
            </Col>
            {
              orderType !== 'DSB'
              && (
                <Col span={24}>
                  <SapSoComponent orderId={orderId} orderType={orderType} simData={simData} orderSoQueue={orderSoQueue} onQueueChange={onQueueChange} isFixItemCat={isFixItemCat} />
                  <Row style={{ float: 'right', paddingTop: 20 }}>
                    <DiscountTotalSoPrice orderId={orderId} orderType={orderType} />
                  </Row>
                </Col>
              )
            }
            <Col span={24}>
              <TempSoComponent orderId={orderId} orderType={orderType} />
            </Col>
          </Row>
          <div style={{ paddingTop: '2em' }}>
            <div>
              <Space style={{ float: 'right' }}>
                {orderType !== 'DSB' && <Button type="primary" icon={<SyncOutlined />} onClick={simulationSo}>Simulation</Button>}
                <Button type="primary" disabled={(disableCreateBtn || editOrderBtn) && orderType !== 'DSB'} icon={<PlusOutlined />} onClick={() => { orderType === 'DSB' ? confirmCreateDSB() : setVisible(!visible) }}>Create</Button>
              </Space>
            </div>
            <Button icon={<LeftOutlined />} style={{ float: 'left' }} onClick={() => history.push('/order')}>Back</Button>
          </div>
        </PageHeader>
      </Spin>
      <Modal
        title="Create So"
        visible={visible}
        maskClosable={false}
        closable={false}
        footer={[
          <Button loading={isLoading} onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  createSo(values.username, values.password, values.order, values.docType, values.assetCat, values.assNo)
                })
                .catch((info) => {
                  console.log('Validate Failed:', info)
                })
            }}
          >
            Submit
          </Button>,
        ]}

      >
        <Form
          name="createSo"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
          form={form}
          {...layout}
          size="small"
          initialValues={{
            order: 'so',
          }}
        >

          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input autocomplete="off" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password autocomplete="off" />
          </Form.Item>

          <Form.Item
            label="Order"
            name="order"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Type"
              onChange={handleOrderChange}
            >
              <Option value="so">Customized Order</Option>
              <Option value="pr1">Display Asset Order</Option>
              <Option value="pr2">Display Store(stock) Order</Option>
              <Option value="pr3">Supplement Order</Option>
            </Select>
          </Form.Item>

          {selectedOrderType === 'pr1' && (
            <>
              <Form.Item
                label="Asset No"
                name="assNo"
                rules={[{ required: true, message: 'Please input the Asset No!' }]}
              >
                <Input />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
    </>
  )
}

export default CreateOrder
